import React from 'react';
import { Label, TextField, Text, Icon, DefaultButton } from '@fluentui/react';
import ComboBoxSearch from '../../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import { Club } from '../../../system/Club/Club';
import { DocumentoTipo } from '../../../system/DocumentoTipo/DocumentoTipo';
import { Jugador } from '../../../system/Jugador/Jugador';
import SingleFileDropzone from '../../Common/FileDropzone/SingleFileDropzone';

interface IConfirmacion {
  jugador: Jugador;
  showEmailLegend: boolean;
  reset: () => void;
}
export const Confirmacion = (props: IConfirmacion) => {
  return (
    <div className="text-center">
      <div>
        <Icon iconName="SkypeCircleCheck" style={{ fontSize: 100, color: '#107C10' }}></Icon>
      </div>
      <div className="mt-2">
        <Text block variant="xLarge">
          ¡Listo {props.jugador.getNombre().split(' ')[0]}!
        </Text>
        <Text block className="mt-2" variant="large">
          Ya registramos tu apto médico.
        </Text>
        {props.showEmailLegend && (
          <Text block className="mt-2" variant="smallPlus">
            Te enviamos un comprobante a tu email
          </Text>
        )}
      </div>
      <div className="mt-2">
        <DefaultButton text="Volver al inicio" onClick={props.reset} />
      </div>
    </div>
  );
};
